import { Factory } from '../../../lib/api';
const getAreas = (params) => Factory.get('api/v2/areas', params);
export default getAreas;
